module.exports = {
  formatRupiah: (val) => {
    if (val > 999999999999) {
      return `Rp. ${(val / 1000000000000).toFixed(2)} Triliun`
    } else if (val > 999999999) {
      return `Rp. ${(val / 1000000000).toFixed(2)} Miliar`
    } else if (val > 999999) {
      return `Rp. ${(val / 1000000).toFixed(0)} Juta`
    } else if (val > 999) {
      return `Rp. ${(val / 1000).toFixed(0)} Ribu`
    } else {
      return `${val.toFixed(2)}`
    }
  }
}